"use strict";

var cov_1irbf81buw = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\resources\\Resource.context.js";
  var hash = "1031d89688f1c7514b29c14a8a7a2b02ed8f548b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\resources\\Resource.context.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 31
        },
        end: {
          line: 6,
          column: 54
        }
      },
      "1": {
        start: {
          line: 17,
          column: 14
        },
        end: {
          line: 24,
          column: 4
        }
      },
      "2": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 28,
          column: 4
        }
      },
      "3": {
        start: {
          line: 31,
          column: 0
        },
        end: {
          line: 47,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "ResourceContextProvider",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 39
          }
        },
        loc: {
          start: {
            line: 16,
            column: 3
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "1031d89688f1c7514b29c14a8a7a2b02ed8f548b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceContextProvider = ResourceContextProvider;
exports.default = exports.ResourceContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _ = require("..");

var ResourceContext = (cov_1irbf81buw.s[0]++, _react.default.createContext({}));
exports.ResourceContext = ResourceContext;

function ResourceContextProvider(_ref) {
  var resource = _ref.resource,
      resourceLink = _ref.resourceLink,
      onResourceLink = _ref.onResourceLink,
      reference = _ref.reference,
      config = _ref.config,
      onResource = _ref.onResource,
      children = _ref.children;
  cov_1irbf81buw.f[0]++;
  var val = (cov_1irbf81buw.s[1]++, (0, _.useResource)({
    resource: resource,
    resourceLink: resourceLink,
    onResourceLink: onResourceLink,
    reference: reference,
    config: config,
    onResource: onResource
  }));
  cov_1irbf81buw.s[2]++;
  return _react.default.createElement(ResourceContext.Provider, {
    value: val
  }, children);
}

cov_1irbf81buw.s[3]++;
ResourceContextProvider.propTypes = {
  /** the resource content */
  resource: _propTypes.default.object,

  /** The link to parse and fetch the resource manifest */
  resourceLink: _propTypes.default.string.isRequired,

  /** The configuration of the server, and fetching */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired,

    /** the overriding cache settings */
    cache: _propTypes.default.shape({
      /** cache age in ms */
      maxAge: _propTypes.default.number
    })
  }),

  /** action taken after a resource is acquired */
  onResource: _propTypes.default.func.isRequired
};
var _default = ResourceContextProvider;
exports.default = _default;